import axios, { AxiosResponse } from 'axios';
import { makeApiUrl } from '../../../shared/util';
import { MembershipResponse } from '../type';
import { QuestionServiceB } from '../../Question/outbound/back';

export const getStoreIdByProjectId = async (project_id: string) => {
  const { data } = await axios.get<string, AxiosResponse<MembershipResponse<{ store_id: number }>>>(
    makeApiUrl('/@api/projects/:project_id/store', { project_id }),
    {
      params: {
        project_id,
      },
    },
  );
  return data;
};

export const getCommissionQuestion = async (commission_request_id: string) => {
  const { data } = await axios.get<
    string,
    AxiosResponse<MembershipResponse<Awaited<ReturnType<typeof QuestionServiceB.getQuestionsByOption>>>>
  >('/@api/questions/commission', {
    params: {
      commissionRequestId: commission_request_id,
    },
  });

  return data;
};
